export default __webpack_public_path__ + "static/media/bootstrap2.544821a7.svg";